import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

/**
 * Risk Name field definition
 * Free-text input (no preset values)
 */
export const RiskName: SimpleFilterDefinition = {
  apiField: 'title',
  uiField: 'Name',
  inputType: 'text', // Text input, no dropdown
  operators: ['is', 'is not', 'contains', 'starts with', 'ends with'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    return {
      field: 'Name',
      operator: getOperatorFromQueryFilter(queryFilter),
      value: queryFilter.value as string | string[],
    };
  },

  matchesQueryFilter: (queryFilter: QueryFilter): boolean => {
    return (
      queryFilter.field === 'title' &&
      queryFilter.relationshipNodeLabel === 'Vulnerability' &&
      queryFilter.relationshipDirection === 'target' &&
      queryFilter.relationshipLabel === 'INSTANCE_OF'
    );
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    return {
      field: 'title',
      operator: getOperatorFromSimpleFilter(simpleFilter),
      value: simpleFilter.value,
      not: getNotFromSimpleFilter(simpleFilter),
      relationshipNodeLabel: 'Vulnerability',
      relationshipDirection: 'target',
      relationshipLabel: 'INSTANCE_OF',
    };
  },
};
